// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".kbSearchList__list___YnBPx{min-height:100px;flex-grow:1;overflow-y:auto}.kbSearchList__listLoading___lxlYU{display:flex;align-items:center;justify-content:center;background-color:#fff}.kbSearchList__empty___1GFLn{display:flex;flex-direction:column;align-items:center;text-align:center;padding:45px 20px 10px}.kbSearchList__articlesEmpty___3sGZk{min-height:129px}.kbSearchList__emptyMessage___3jFIi{font-size:12px;margin-top:10px}.kbSearchList__headerContainer___2m-Xk{background-color:#fff;padding:20px;border-bottom:1px solid #e9eff5}.kbSearchList__headerTitle___11ioL{font-size:18px;font-weight:500;margin-bottom:10px}.kbSearchList__headerDescription___3EzQR{color:#717070}@keyframes kbSearchList__animation-spinner___MJEhs{0%{transform:rotate(0deg)}50%{transform:rotate(180deg)}100%{transform:rotate(360deg)}}.kbSearchList__loader___3hXd5{width:35px;height:35px;border-radius:100%;border-width:1px;border-style:solid;border-image:initial;border-color:#717070 #717070 #0000;display:inline-block;animation:kbSearchList__animation-spinner___MJEhs 1s linear infinite;background:#0000 !important}@keyframes kbSearchList__animation-spinner___MJEhs{0%{transform:rotate(0deg)}50%{transform:rotate(-180deg)}100%{transform:rotate(-360deg)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"white": "#fff",
	"primary": "#222",
	"secondary": "#717070",
	"primaryBlue": "#336dec",
	"primaryDarkerBlue": "#005bcc",
	"chatIconFrameWidth": "70px",
	"chatIconFrameHeight": "70px",
	"widgetFrameWidth": "400px",
	"widgetFrameHeight": "650px",
	"mobileScreenWidth": "550px",
	"mobileScreenHeight": "655px",
	"list": "kbSearchList__list___YnBPx",
	"listLoading": "kbSearchList__listLoading___lxlYU",
	"empty": "kbSearchList__empty___1GFLn",
	"articlesEmpty": "kbSearchList__articlesEmpty___3sGZk",
	"emptyMessage": "kbSearchList__emptyMessage___3jFIi",
	"headerContainer": "kbSearchList__headerContainer___2m-Xk",
	"headerTitle": "kbSearchList__headerTitle___11ioL",
	"headerDescription": "kbSearchList__headerDescription___3EzQR",
	"loader": "kbSearchList__loader___3hXd5",
	"animation-spinner": "kbSearchList__animation-spinner___MJEhs"
};
export default ___CSS_LOADER_EXPORT___;
